import React from 'react';
const VrArHero = () => {
  // Define S3 URL here
  const VIDEO_URL = "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hero/vrar_hero.87a8fe08bc4ea496fcd3.mp4";

  return (
    <div className="position-relative overflow-hidden min_vrar_hero_h">
      <video
        autoPlay
        muted
        loop
        playsInline
        className="w-100 h-100 object-fit-cover position-absolute top-0 start-0"
      >
        <source src={VIDEO_URL} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VrArHero;